import { isHyperlinkAllowed } from '../wrappers/filter';
/** Depending on parameters rules will not call the following chained middlewares */
export function IgnoreFollowingsMiddleware(options) {
    return (properties, element, next) => {
        if (options) {
            if (isHyperlinkAllowed(properties.href, {
                applyPatterns: options.applyPatterns,
                skipPatterns: options.skipPatterns,
            })) {
                return next();
            }
            else {
                return;
            }
        }
        next();
    };
}
//# sourceMappingURL=ignore-followings.js.map